module.exports = __webpack_public_path__ + "img/cp73-r3.4b634fce.jpg";